import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "bulma/bulma.sass";
import "aos/dist/aos.css";
import "./styles/global.scss";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./reducers";
import Fallback from "./components/extra/fallback";
import { ConfigProvider } from "antd";

const Main = lazy(() => import("./main"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense fallback={<Fallback />}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                colorPrimary: "#4891CA",
              },
            },
          }}
        >
          <BrowserRouter>
            <Main />
          </BrowserRouter>
        </ConfigProvider>
      </Suspense>
    </Provider>
  </React.StrictMode>
);
